import { useEffect, useMemo } from 'react';
import { CardTypesEnum, HealthPlanStatuses, useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { OrganizationTypes } from '@/common/constants';
import { Pagination } from '@/common/types';
import { API_URL, IHealthPlanBaseDto } from '@/dtos';
import { useCurrentOrganization } from '@/modules/core';
import { HealthPlanFieldState } from '@/modules/HealthPlan/HealthPlan.types';
import { getIdsFromPath } from '@/utils';

export const getPlanList = (id: null | string, status?: HealthPlanStatuses) => () =>
  api.get<Pagination<IHealthPlanBaseDto>>(API_URL.HEALTH_PLANS, {
    params: {
      organization_id: id || undefined,
      plan_status: status || undefined,
      size: 100,
    },
  });

export const HEALTH_PLAN_LIST_QUERY_NAME = 'getHealthPlansList';

export const useHealthPlansListQuery = (id?: string | null, status?: HealthPlanStatuses) => {
  // const isSuperUser = useIsOrganizationType(OrganizationTypes.system);
  const {
    observingOrganization: { type, id: observingOrganizationId, path },
  } = useCurrentOrganization();

  const { employerId } = getIdsFromPath(path);

  const isSubsidiary = useMemo(() => type === OrganizationTypes.subsidiary, [type]);

  const organizationId = useMemo(
    () => (isSubsidiary ? employerId : observingOrganizationId),
    [isSubsidiary, employerId, observingOrganizationId]
  );

  const currentId = useMemo(() => id || organizationId || '0', [id, organizationId]);

  const { isLoading, error, data, isSuccess, isError, refetch } = useQuery(
    [HEALTH_PLAN_LIST_QUERY_NAME, currentId, status],
    getPlanList(currentId, status),
    {
      refetchOnMount: true,
      cacheTime: 0,
    }
  );
  useEffect(() => {
    if (organizationId && !id) refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationId, id]);
  const formatedPlans = useMemo(() => {
    const list = data?.data?.content || [];
    return list.map((item) => ({
      id: `${item.id}`,
      name: item?.name?.name || '',
      typeState: item?.health_plan_types?.health_plan_type_state as unknown as HealthPlanFieldState,
      status: item.plan_status as HealthPlanStatuses,
      types: item?.health_plan_types?.health_plan_types as unknown as CardTypesEnum[],
      planYearId: item.plan_year?.id,
      planYearName: item.plan_year?.name,
    }));
  }, [data]);

  return {
    data: formatedPlans,
    error,
    isError,
    isLoading,
    isSuccess,
    refetch,
  };
};
export default useHealthPlansListQuery;
